import {load} from 'dataModulesLoader';
import {bootstrap} from './bootstrap';

load({whitelabelling: true, timezones: true}).done(() => bootstrap());
